AFRAME.registerComponent('scene3', {
  schema: {
    sceneModel: {default: ''},
    nftTextureSrc: {default: ''},
    frameStyle: {default: 1, min: 1, max: 10},
    roomStyle: {default: 1, min: 1, max: 6},
    aspectRatio: {default: 'squared', oneOf: ['squared', 'portrait', 'landscape']},
    nftColors: {default: true},
    fogDensity: {default: 0.034}
  },

  textures: [
    './assets/textures/scene3/style1.jpg',
    './assets/textures/scene3/style2.jpg',
    './assets/textures/scene3/style3.jpg',
    './assets/textures/scene3/style4.jpg',
    './assets/textures/scene3/style5.jpg',
    './assets/textures/scene3/style6.jpg',
    './assets/textures/scene3/lightmap-landscape.jpg',
    './assets/textures/scene3/lightmap-portrait.jpg',
    './assets/textures/scene3/lightmap-squared.jpg'
  ],

  cameraAnimations: [
    {
      initialPosition: new THREE.Vector3(1, 0.8, 0),
      initialRotation: new THREE.Vector3(0, 0, 0),
      finalPosition: new THREE.Vector3(-0.19, 0.8, 0),
      finalRotation: new THREE.Vector3(0, 0, 0),
      duration: 5000
    },
    {
      initialPosition: new THREE.Vector3(0, 1.4, 0),
      initialRotation: new THREE.Vector3(0, 0, 0),
      finalPosition: new THREE.Vector3(0, 1.4, -0.796),
      finalRotation: new THREE.Vector3(0, 0, 0),
      duration: 5000
    }
  ],

  init: function () {
    var system = this.el.sceneEl.systems.scene;
    this.onModelLoaded = system.onModelLoaded.bind(this);
    this.onTexturesPreloaded = this.onTexturesPreloaded.bind(this);
    this.el.sceneEl.addEventListener('texturespreloaded', this.onTexturesPreloaded);
    this.el.addEventListener('model-loaded', this.onModelLoaded);
    this.el.setAttribute('gltf-model', this.data.sceneModel);
    system.registerScene(this.el);
    system.initCanvasTextures(this);

    this.materials = {};
  },

  update: function () {
    var system = this.el.sceneEl.systems.scene;
    system.updateModel(this);
  },

  onTexturesPreloaded: function () {
    this.texturesPreload
  }
});